var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "phovn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5ZM4.125 10.5C4.125 14.015 6.985 16.875 10.5 16.875C14.015 16.875 16.875 14.015 16.875 10.5C16.875 6.985 14.015 4.125 10.5 4.125C6.985 4.125 4.125 6.985 4.125 10.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.636 17.214L20.708 19.294C21.098 19.685 21.097 20.318 20.706 20.708C20.511 20.903 20.255 21 20 21C19.744 21 19.487 20.902 19.291 20.706L17.219 18.626L18.636 17.214Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e1fdd31ea0be4ec9f901b74717019178.svg";
export { ForwardRef as ReactComponent };